'use-client';
import * as React from 'react';
import type {
  IContainerProps,
  IContainerImperativeActions,
} from '../../../Container.types';
import { BubbleSkinContainer } from '../../shared/BubbleSkinContainer';
import styles from './BubbleLeftArea.scss';

const BubbleLeftArea: React.ForwardRefRenderFunction<
  IContainerImperativeActions,
  IContainerProps
> = (props, ref) => {
  return <BubbleSkinContainer ref={ref} {...props} classes={styles} />;
};

export default React.forwardRef(BubbleLeftArea);
